export default __webpack_public_path__ + "static/media/hero-purple-mobile.24c693f0.jpg";